<app-navigator [navigator]="navigator"></app-navigator>

<hr>

<ng-container *ngIf="resellers; else waiting">
    <div class="row">
        <div class="form-group"  [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
            <label class="roboSubTitle" for="admin">{{ 'stats.usersState' | translate }}</label>
            <div class='row' style="margin-left: 5px">
            <div class="form-check col-auto">
                <input class="form-check-input" type="radio" name="group1" id="flexRadioDefault1" (click) = "setUserState('')" checked>
                <label class="form-check-label" for="flexRadioDefault1">
                    {{ 'stats.all' | translate }}
                </label>
            </div>
            <div class="form-check  col-auto">
                <input class="form-check-input" type="radio" name="group1" id="flexRadioDefault1" (click) = "setUserState('1')">
                <label class="form-check-label" for="flexRadioDefault1">
                    {{ 'stats.active' | translate }}
                </label>
            </div>
            <div class="form-check  col-auto">
                <input class="form-check-input" type="radio" name="group1" id="flexRadioDefault1" (click) = "setUserState('0')">
                <label class="form-check-label" for="flexRadioDefault1">
                    {{ 'stats.disabled' | translate }}
                </label>
            </div>
        </div>
        </div>
        <div class="form-group"  [ngClass]="{'col-2' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
            <label class="roboSubTitle" for="environment">Reseller </label>
            <app-select class="selectDm7" 
                [options]="resellers" [key]="'id'" [value]="'username'"
                [placeholder]="'placeholder.select' | translate" [addNull]="true" 
                (change)="selectedReseller = $event.key"></app-select>
        </div>
        <div class= "form-group col-auto">
            <button type="button" class="btn btn-primary" style="margin-top: 30px;" (click)="getTable()"> {{ 'general.search' | translate }}</button> 
        </div>
    </div>
    <hr>

    <ng-container *ngIf='search'>
        <div [ngStyle]="{'justify-content': innerWidth! > 767 ? 'flex-end' : '100%'}" style="margin-bottom: 10px; margin-top:10px">
            <div class="row justify-content-between">
              <div class='col-auto' style="display: flex; flex-direction: row;">
                <label  class="form-check-label" style='margin-right: 5px;'>{{'general.show' | translate}}</label>
                  <div class="dm7Select" >
                      <div class="select-side">
                        <img src="assets/icone_varie/arrow_down.svg">
                      </div>
                      <app-select class="selectDm7" 
                              [options]="pages" [key]="'key'" [value]="'key'"
                              [placeholder]="'placeholder.select' | translate" [addNull]="false" [selectedKey]="pages[1].key"
                              (change)="changePageSize($event.key)"></app-select>
                  </div>
                  <label  class="form-check-label">{{'paginator.rows' | translate}}</label>
              </div>
             
              <div class="col-4 ">
                <app-paginator [ngStyle]="{'width': innerWidth! > 767 ? 'auto' : '60%'}" *ngIf="statsTable" 
                      [config]="statsTable" (refresh)="getTable()" (next)="next()" (prev)="prev()"></app-paginator>
              </div>  
            </div>
              
          </div>

        <ng-container *ngIf="statsTable; else waiting">
            <div  *ngIf="statsTable.data && statsTable.data.length > 0; else noRes">
            <table class="table" >
                <thead>
                <tr >
                    <th scope="col" (click)="sort('username')" style="cursor: pointer;">Username <img [src]="'assets/icone_varie/' + sortUtils.getImgSort('username')" style="width: 20px;"></th> 
                    <th scope="col">{{'stats.table.den' | translate}}</th>
                    <th scope="col" (click)="sort('id_utente_admin')" style="cursor: pointer;">{{'stats.table.admin' | translate}} <img [src]="'assets/icone_varie/' + sortUtils.getImgSort('username')" style="width: 20px;"></th>
                    <th scope="col" (click)="sort('id_utente_reseller')" style="cursor: pointer;">{{'stats.table.reseller' | translate}} <img [src]="'assets/icone_varie/' + sortUtils.getImgSort('username')" style="width: 20px;"></th> 
                    <th scope="col">{{'stats.table.sentInvs' | translate}}</th>
                    <th scope="col">{{'stats.table.receivedInvs' | translate}}</th>
                    <th scope="col">{{'stats.table.lastInvs' | translate}}</th>
                    <th scope="col">{{'stats.table.sentOrds' | translate}}</th>
                    <th scope="col">{{'stats.table.receivedOrds' | translate}}</th>
                    <th scope="col">{{'stats.table.lastOrds' | translate}}</th>
                   
                </tr>
                </thead> 
                <tbody>
                <tr *ngFor="let u of statsTable.data;"  >
                    <td>
                    {{u.username}}
                    </td>
                    <td>
                    {{u.json_sdi_data != 'null' ? getJsonData(u).DatiAnagrafici.Anagrafica.Denominazione: ''}}
                    </td>
                    <td>
                    {{u.username_utente_admin}}
                    </td>
                    <td>
                        {{u.username_utente_reseller}}
                    </td>
                    <td>
                        {{u.fattureAttive}}
                    </td>
                    <td>
                        {{u.fatturePassive}}
                    </td>
                    <td>
                        {{u.limite_fatture}}
                    
                    </td>
                    <td>
                        {{u.ordiniInviati}}
                    </td>
                    <td>
                        {{u.ordiniRicevuti}}
                    </td>
                    <td>
                        {{u.limite_ordini}}
                    </td>
                   
                </tr>
                </tbody>
            </table>
            </div>
        </ng-container>
    </ng-container>
    <ng-template #noRes>
        <div>
          <ngb-toast [autohide]="false" class="warning">
              <img src="assets/icone_varie/info.png" style="width: 20px; margin-right: 5px;">
              {{'general.noResults' | translate}}
          </ngb-toast>
        </div>
      </ng-template>
     
</ng-container>

<ng-template #waiting>
    <app-loading></app-loading>
  </ng-template>